import {cn} from '@/lib/utils';
import {IContactPageFormDictionary} from '@/dictionaries/pages/contacts/types';

type Props = {
  formType: string;
  onToggle: (value: string) => void;
  dict: IContactPageFormDictionary;
};

export default function FormTypeToggle({formType, onToggle, dict}: Props) {
  return (
    <div className="flex flex-col py-[2rem]">
      <label className="text-sm text-gray-700 leading-[1.8]">
        {dict.accountType}
      </label>
      <div className="flex bg-gray-100 border border-gray-200 desktop:w-[66%]">
        <div className="relative flex items-center justify-center w-1/2 min-h-[42px]">
          <input
            onChange={(e) => onToggle(e.target.value)}
            value="guest"
            checked={formType == 'guest'}
            id="0"
            type="radio"
            className="absolute left-0 right-0 top-0 bottom-0 mb-4 invisible w-full h-full"
          />
          <label
            htmlFor="0"
            className={cn(
              'cursor-pointer w-full h-full text-md text-center m-0 relative p-3 transition ease-in-out duration-[800ms]',
              {
                'bg-blue text-white': formType == 'guest',
              },
            )}>
            {dict.travellers}
          </label>
        </div>
        <div className="relative flex items-center justify-center w-1/2 min-h-[42px]">
          <input
            onChange={(e) => onToggle(e.target.value)}
            checked={formType == 'owner'}
            value="owner"
            id="1"
            type="radio"
            className="absolute left-0 right-0 top-0 bottom-0 mb-4 invisible w-full h-full"
          />
          <label
            htmlFor="1"
            className={cn(
              'cursor-pointer w-full h-full text-md text-center m-0 relative p-3 transition ease-in-out duration-[800ms]',
              {
                'bg-blue text-white': formType == 'owner',
              },
            )}>
            {dict.villaOwners}
          </label>
        </div>
      </div>
    </div>
  );
}
